import * as React from "react"
import { Link, graphql } from "gatsby"

// import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"

const SERIES_META = {
  "browser-concurrency": {
    title: "Browser Concurrency",
    description:
      "A practical guide to sharing data and coordinating work across browser threads — tabs, workers, and shared memory.",
  },
  "frontend-system-design": {
    title: "Frontend System Design Interview Prep",
    description:
      "A complete guide to acing frontend system design interviews — from the RADIO framework to real-world component designs asked at FAANG.",
  },
}

const SERIES_ORDER = ["frontend-system-design", "browser-concurrency"]

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const posts = data.allMdx.nodes

  // Count articles per series
  const seriesCounts = {}
  posts.forEach(post => {
    const s = post.frontmatter.series
    if (s) seriesCounts[s] = (seriesCounts[s] || 0) + 1
  })

  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>
        {/* <Bio /> */}
        <p>
          No blog posts found. Add markdown posts to "content/blog" (or the
          directory you specified for the "gatsby-source-filesystem" plugin in
          gatsby-config.js).
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location} title={siteTitle}>
      {/* <Bio /> */}

      {/* Series Section */}
      {SERIES_ORDER.some(s => seriesCounts[s]) && (
        <section aria-labelledby="series-heading" style={{ marginBottom: "2.5rem" }}>
          <h2
            id="series-heading"
            style={{
              fontFamily: "var(--fontFamily-sans, system-ui, sans-serif)",
              fontSize: "var(--fontSize-2, 1.2rem)",
              fontWeight: 700,
              color: "var(--color-text-light, #4f5969)",
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              marginBottom: "1rem",
              marginTop: 0,
            }}
          >
            Series
          </h2>
          {SERIES_ORDER.filter(s => seriesCounts[s]).map(slug => {
            const meta = SERIES_META[slug]
            const count = seriesCounts[slug] || 0
            return (
              <div key={slug} className="series-card">
                <h3>
                  <Link
                    to={`/series/${slug}/`}
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    {meta.title}
                  </Link>
                </h3>
                <p className="series-desc">{meta.description}</p>
                <p className="series-meta">
                  {count} article{count !== 1 ? "s" : ""} ·{" "}
                  <Link
                    to={`/series/${slug}/`}
                    style={{ color: "#4f46e5", fontWeight: 600 }}
                  >
                    View series →
                  </Link>
                </p>
              </div>
            )
          })}
        </section>
      )}

      {/* All Posts */}
      <ol style={{ listStyle: `none` }}>
        {posts.map(post => {
          const title = post.frontmatter.title || post.fields.slug

          return (
            <li key={post.fields.slug}>
              <article
                className="post-list-item"
                itemScope
                itemType="http://schema.org/Article"
              >
                <header>
                  <h2>
                    <Link to={post.fields.slug} itemProp="url">
                      <span itemProp="headline">{title}</span>
                    </Link>
                  </h2>
                  <small>
                    {post.frontmatter.category && (
                      <span className="category-pill">{post.frontmatter.category}</span>
                    )}
                    {post.frontmatter.date}
                  </small>
                </header>
                <section>
                  <p
                    itemProp="description"
                  >{post.frontmatter.description}</p>
                </section>
              </article>
            </li>
          )
        })}
      </ol>
    </Layout>
  )
}

export default BlogIndex

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="All posts" />

export const pageQuery = graphql`
  {
    site {
      siteMetadata {
        title
      }
    }
    allMdx(sort: { frontmatter: { date: DESC } }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          category
          series
        }
      }
    }
  }
`
